//Přidat highlight na bod HOTOVO//opravit aby člověk nemohl přidat bod když neni vybrana poloha
HOTOVO //udelat jak to funguje button Částečně HOTOVO//design log HOTOVO// Esri //dodělat udalosti
//mobile view //přidat animace na otevirani a zavirani oken HOTOVO//udělat všechny body orandžové
//editace HOTOVO//tokeny HOTOVO //captcha

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import Map from '@arcgis/core/Map'
import Basemap from '@arcgis/core/Basemap'

import Graphic from '@arcgis/core/Graphic'
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol'
import Point from '@arcgis/core/geometry/Point'

import VectorTileLayer from '@arcgis/core/layers/VectorTileLayer'
import FeatureLayer from '@arcgis/core/layers/FeatureLayer'
import ImageryTileLayer from '@arcgis/core/layers/ImageryTileLayer'

import type { ClickEvent, PointerMoveEvent } from '@arcgis/core/views/input/types'

import '@arcgis/map-components/components/arcgis-map'
import '@arcgis/map-components/components/arcgis-expand'
import '@arcgis/map-components/components/arcgis-basemap-toggle'
//import '@arcgis/map-components/components/arcgis-basemap-gallery'
import '@arcgis/map-components/components/arcgis-locate'
import '@arcgis/map-components/components/arcgis-zoom'
import '@arcgis/map-components/components/arcgis-home'

import { assignTokens /*addTokenToUrl*/ } from '../utils/tokens'
import type { PoemAttributes } from '../types/types'
import { HideEsri } from '@/utils/hideEsri'

//import LocalBasemapsSource from '@arcgis/core/widgets/BasemapGallery/support/LocalBasemapsSource'

import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer'
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer'

const emit = defineEmits(['location-selected', 'close-all', 'open-poem', 'edit-poem', 'close-poem'])
const props = defineProps<{
  isAddPlaceOpen: boolean
}>()
const isPoemLocked = ref(false)
let hoverTimeout: number | undefined

const sessionMarkersLayer = new GraphicsLayer({
  title: 'SessionMarkersLayer',
})
//metoda na mazani bodu ktere nejsou v protectedMarkerIds arrayi
const clearMarkers = () => {
  const viewElement = document.querySelector('arcgis-map')
  if (!viewElement || !viewElement.graphics) return

  viewElement.graphics.removeAll()
}

const addMarker = (point: Point, isAdded: boolean = false) => {
  const viewElement = document.querySelector('arcgis-map')
  if (!viewElement) return

  clearMarkers()

  const markerId = crypto.randomUUID()

  //vzhled přidaného bodu
  const poemSymbol = new SimpleMarkerSymbol({
    color: [226, 119, 40],
    size: 8,
    outline: {
      color: [255, 255, 255],
      width: 2,
    },
  })

  const pointGraphic = new Graphic({
    geometry: point,
    symbol: poemSymbol,
    ...(isAdded && { attributes: { IDSEZENI: markerId } }),
  })
  if (isAdded) {
    sessionMarkersLayer.add(pointGraphic)
  } else {
    viewElement.graphics.add(pointGraphic)
  }
}

const vectorBaseLayer = new VectorTileLayer({
  url: 'https://iprpraha.maps.arcgis.com/sharing/rest/content/items/50f872ac3f85435baf86c2443b247af7/resources/styles/root.json',
})

const orthoLayer = new ImageryTileLayer({
  url: 'https://gs-prv.praha.eu/imgs/rest/services/ort/letecke_snimkovani/ImageServer',
})

const mapBasemap = new Basemap({
  baseLayers: [vectorBaseLayer],
  title: 'Základní mapa',
  id: 'zakladni-mapa',
  thumbnailUrl: './images/MTVU.png',
})

const orthoBasemap = new Basemap({
  baseLayers: [orthoLayer],
  title: 'Letecká mapa',
  id: 'letecka-mapa',
  thumbnailUrl: './images/letecke_snimky_posledni_snimkovani_cache.png',
})
//design pro importovanou vrstvu poeticPlacesLayer
const poeticPlacesRender = new SimpleRenderer({
  symbol: new SimpleMarkerSymbol({
    color: [255, 255, 255],

    size: 8,

    outline: {
      color: [0, 0, 0],

      width: 2,
    },
  }),
})
//tokeny vytvořeno s ai pro debugging
/*async function testServerConnection() {
  const testUrl =
    'https://gp-dc.iprpraha.cz/arcgis/rest/services/app_agendy/praha_poeticka_v2/FeatureServer/0?f=json'

  // Use your exact function
  const securedUrl = addTokenToUrl(testUrl)
  console.log('Testing this exact URL:', securedUrl)

  try {
    const response = await fetch(securedUrl)
    if (response.ok) {
      const data = await response.json()
      console.log('SUCCESS! The server responded:', data)
      // If you see this, your token and network are perfect.
      // The issue is purely how the FeatureLayer is set up.
    } else {
      console.error('SERVER REJECTED IT. Status:', response.status)
      // If you get 401 or 403, your token string is invalid/expired.
    }
  } catch (error) {
    console.error('NETWORK CRASHED:', error)
    // If you get ERR_CONNECTION_RESET here, your VPN, Antivirus,
    // or Adblocker is 100% blocking the connection.
  }
}*/

onMounted(async () => {
  //počkaní na tokeny
  await assignTokens()
  //debugging
  //console.log(window.app.tokens)

  //testServerConnection()
  //konc token debuggingu
  //načítání vrstvy s body
  const poeticPlacesLayer = new FeatureLayer({
    id: 'poeticPlacesLayer',
    url: 'https://gp-dc.iprpraha.cz/arcgis/rest/services/app_agendy/praha_poeticka/FeatureServer/0',
    //testovaci  vrstva dole
    //url: 'https://gp-dc.iprpraha.cz/arcgis/rest/services/app_agendy/praha_poeticka_v2/FeatureServer/0',
    popupEnabled: false,
    outFields: ['*'],
    renderer: poeticPlacesRender,
  })

  const viewElement = document.querySelector('arcgis-map')
  const toggleBasemapElement = document.querySelector('arcgis-basemap-toggle')

  if (viewElement) {
    viewElement.map = new Map({
      basemap: mapBasemap,
      layers: [poeticPlacesLayer, sessionMarkersLayer],
    })

    viewElement.addEventListener('arcgisViewReadyChange', () => {
      HideEsri()
      if (viewElement.view) {
        viewElement.view.constraints.rotationEnabled = false
      }
    })

    viewElement.addEventListener('arcgisViewClick', (event: CustomEvent<ClickEvent>) => {
      handleClick(event.detail.x, event.detail.y)
    })
    viewElement.addEventListener(
      'arcgisViewPointerMove',
      (event: CustomEvent<PointerMoveEvent>) => {
        handleHover(event.detail.x, event.detail.y)
      },
    )
  }
  if (toggleBasemapElement) {
    toggleBasemapElement.nextBasemap = orthoBasemap
  }
})

async function checkforMarkers(x: number, y: number) {
  const viewElement = document.querySelector('arcgis-map')
  if (!viewElement || !viewElement.map) return null

  const poeticPlacesLayer = viewElement.map.layers.find(
    (layer) => layer.id === 'poeticPlacesLayer',
  ) as FeatureLayer
  if (poeticPlacesLayer) {
    const response = await viewElement.hitTest(
      { x, y },
      { include: [poeticPlacesLayer, sessionMarkersLayer] },
    )
    if (response.results.length) {
      const hitResult = response.results[0]
      if ('graphic' in hitResult && hitResult.graphic.attributes) {
        return hitResult.graphic
      }
    }
  }
  return null
}
// ohlidani hover effektu pro zobrazeni basni pri najeti mysi
async function handleHover(x: number, y: number) {
  const isMarkerModeActive = document.body.classList.contains('marker-cursor-active')
  if (isMarkerModeActive || props.isAddPlaceOpen) return
  //hittest zjisti zda li je pod kurzorem bbod
  const result = await checkforMarkers(x, y)
  //pokud najde bod, resetuje ostatní hodnoty a zvyrazni dany bod + otevre basen
  if (result) {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout)
      hoverTimeout = undefined
    }
    if (result.layer === sessionMarkersLayer) {
      const point = result.geometry as Point
      emit('edit-poem', {
        x: point.longitude ?? point.x,
        y: point.latitude ?? point.y,
        attributes: result.attributes,
      })
    } else {
      //isAddedPoem.value = false
      emit('location-selected', null)
      addMarker(result.geometry as Point)
      emit('open-poem', result.attributes)
    }
    //pokud nenajde zadny bod a uzivatel nepridava vlastni body tak zresetuje vsechnu grafiku
  } else {
    if (!isPoemLocked.value) {
      if (!hoverTimeout) {
        hoverTimeout = window.setTimeout(() => {
          clearMarkers()
          emit('close-poem')
          hoverTimeout = undefined
        }, 10000) // 10000 milliseconds = 10 seconds
      }
    }
  }
}
//funkcionalita klikani
async function handleClick(x: number, y: number) {
  const viewElement = document.querySelector('arcgis-map')
  if (!viewElement) return

  const mapPoint = viewElement.toMap({ x, y })
  if (!mapPoint) return

  if (hoverTimeout) {
    clearTimeout(hoverTimeout)
    hoverTimeout = undefined
  }

  const result = await checkforMarkers(x, y)
  //zjisti zda li uzivatel poklada bod
  const isMarkerModeActive = document.body.classList.contains('marker-cursor-active')
  //pokud klikne na bod tak se zresetuji ostatni hodnoty a basen se "uzamkne" aby nezmizela po posunuti mysi
  if (result) {
    if (result.layer && result.layer.title === 'SessionMarkersLayer') {
      const point = result.geometry as Point
      emit('edit-poem', {
        x: point.longitude ?? point.x,
        y: point.latitude ?? point.y,
        attributes: result.attributes,
      })
    } else {
      isPoemLocked.value = true
      //isAddedPoem.value = false
      addMarker(result.geometry as Point)
      emit('open-poem', result.attributes)
      //logika pridavani bodu
    }
  } else if (isMarkerModeActive) {
    //isAddedPoem.value = true
    isPoemLocked.value = false

    addMarker(mapPoint, true)
    emit('location-selected', {
      x: mapPoint.longitude ?? mapPoint.x,
      y: mapPoint.latitude ?? mapPoint.y,
      ID: sessionMarkersLayer.graphics.getItemAt(sessionMarkersLayer.graphics.length - 1)
        ?.attributes?.IDSEZENI,
    })
  } else {
    isPoemLocked.value = false
    //isAddedPoem.value = false
    clearMarkers()
    emit('close-all')
  }
}

defineExpose({
  updateLocalGraphic: (idsezeni: string, objectId: number, attributes: PoemAttributes) => {
    const viewElement = document.querySelector('arcgis-map')
    if (!viewElement) return

    const graphic = sessionMarkersLayer.graphics.find(
      (g: any) => g.attributes?.IDSEZENI === idsezeni,
    )

    if (graphic) {
      console.log('UPDATED ATTRIBUTES')

      const clonedGraphic = graphic.clone()

      clonedGraphic.attributes = { ...graphic.attributes, ...attributes, OBJECTID: objectId }

      sessionMarkersLayer.remove(graphic)
      sessionMarkersLayer.add(clonedGraphic)
    }

    const layer = viewElement.map?.layers.find(
      (l: any) => l.id === 'poeticPlacesLayer',
    ) as FeatureLayer

    if (layer) layer.refresh()
  },
  deleteLocalGraphic: (idsezeni: string, objectId: number) => {
    const viewElement = document.querySelector('arcgis-map')
    if (!viewElement) return

    const graphic = sessionMarkersLayer.graphics.find(
      (g: any) => g.attributes?.IDSEZENI === idsezeni || g.attributes?.OBJECTID === objectId,
    )
    if (graphic) {
      sessionMarkersLayer.remove(graphic)
    }

    const layer = viewElement.map?.layers.find(
      (l: any) => l.id === 'poeticPlacesLayer',
    ) as FeatureLayer
    if (layer) layer.refresh()

    clearMarkers()
  },
})
</script>

<template>
  <div class="map-wrapper">
    <arcgis-map ref="mapContainer" class="map-container" zoom="5" center="14.4208, 50.0878">
      <div slot="bottom-right" class="bottom-right-widget">
        <arcgis-basemap-toggle ref="toggleRef" class="basemap-toggle-full"></arcgis-basemap-toggle>

        <div class="button-row">
          <arcgis-zoom layout="horizontal"></arcgis-zoom>
          <arcgis-locate></arcgis-locate>
          <arcgis-home></arcgis-home>
        </div>
      </div>
    </arcgis-map>
    <div class="custom-esri-panel">
      <p class="attribution-text">
        Powered by
        <a href="https://www.esri.com/" target="_blank" rel="noopener noreferrer">Esri</a> | Mapová
        data poskytuje
        <a href="https://iprpraha.cz/" target="_blank" rel="noopener noreferrer">IPR Praha</a>
      </p>
    </div>
  </div>
</template>

<style scoped>
.custom-esri-panel {
  position: absolute;
  bottom: 0;
  right: 0;
  width: fit-content;

  background-color: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(4px);
  padding: 3px 5px;
  z-index: 10;

  border-top-right-radius: 6px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}
.attribution-text {
  margin: 0;
  padding: 0;
  font-size: 10px;
  font-family: sans-serif;
  color: #4c4c4c;
}

.attribution-text a {
  color: #e27728;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;
}

.attribution-text a:hover {
  text-decoration: underline;
  color: #c0601c;
}
.map-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
}

.map-container {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  --arcgis-view-color-focus: transparent;
}

.bottom-right-widget {
  display: flex;
  flex-direction: column;

  align-items: center;

  gap: 4px;
  margin-bottom: 5px;
  margin-right: 0;
}

.basemap-toggle-full {
  margin: 0;
}

.button-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.button-row arcgis-zoom,
.button-row arcgis-locate {
  margin: 0;
}
</style>
